import Vue from 'vue'
import moment from 'moment'

moment.locale('cs');

Vue.filter('formatToday', function (value) {
    if (typeof value === 'object') {
        value = value.date;
    }

    if (value) {
        if (moment(String(value)).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY')) {
            return 'dnes ' + moment(String(value)).format('HH:mm')
        } else if (moment(String(value)).format('YYYY') !== moment().format('YYYY')) {
            return moment(String(value)).format('DD.MM.YYYY')
        }

        return moment(String(value)).format('DD.MM.')
    }
});

Vue.filter('formatFullDate', function (value) {
    if (typeof value === 'object') {
        value = value.date;
    }

    if (value) {
        if (moment(String(value)).format('YYYY') !== moment().format('YYYY')) {
            return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }

        return moment(String(value)).format('DD.MM. HH:mm')
    }
});

Vue.filter('formatDay', function (value) {
    if (typeof value === 'object') {
        value = value.date;
    }

    if (value) {
        if (moment(String(value)).format('YYYY') !== moment().format('YYYY')) {
            return moment(String(value)).format('DD.MM.YYYY')
        }

        return moment(String(value)).format('DD.MM.')
    }
});
